const RoundType = require('./RoundTypeEnum');

module.exports = function (value, decimals, roundType) {
    switch (roundType) {
        case RoundType.Up:
            return Math.ceil(value);
        case RoundType.Down:
            return Math.floor(value);
        default:
            return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    }
};